// src/schemas/aboutSchema.js

export const aboutBreadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://cfobridge.ae/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "About Us",
      "item": "https://cfobridge.ae/about-us"
    }
  ]
};

export const aboutFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the background and track record of CFO Bridge in the corporate financial sector?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CFO Bridge was founded in India in 2012 with a focus on delivering practical, high-impact financial leadership to growth-stage businesses. Over more than a decade, we have partnered with startups, SMEs, and mid-market companies across multiple sectors, managing over 550 business engagements globally and establishing a strong track record of measurable financial outcomes."
      }
    },
    {
      "@type": "Question",
      "name": "When did CFO Bridge expand its outsourced CFO services into the UAE and MENA market?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CFO Bridge formally expanded into the UAE and MENA market in 2025, bringing its execution-focused CFO model to Dubai and Abu Dhabi. This expansion was driven by the growing demand from UAE-based businesses for flexible, expert-level financial leadership that avoids the cost and commitment of a full-time C-suite hire."
      }
    },
    {
      "@type": "Question",
      "name": "What core organizational values guide the financial consulting at CFO Bridge UAE?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The core values guiding CFO Bridge UAE are Integrity, Respect, Empathy, Transparency, Accountability, Partnership, and a commitment to adding value to all stakeholders. These values define how our CFO consultants engage with clients, make decisions, and build long-term relationships across every engagement in the GCC."
      }
    },
    {
      "@type": "Question",
      "name": "How many global business engagements has the CFO Bridge corporate finance team managed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The CFO Bridge team has collectively managed over 550 business engagements globally across India, the UAE, and the MENA region. These engagements span industries including technology, manufacturing, healthcare, real estate, FMCG, and financial services, reflecting the breadth of our team's expertise."
      }
    },
    {
      "@type": "Question",
      "name": "Why should mid-market companies and startups in Dubai choose CFO Bridge over an in-house hire?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Mid-market companies and startups in Dubai benefit from CFO Bridge because we offer senior CFO-level expertise at a fraction of the cost of a full-time hire. Our partners are seasoned professionals with 20+ years of experience, and our flexible engagement model means you get precisely the financial leadership your business needs — without the overhead, HR complexities, or long-term commitment of an in-house CFO."
      }
    },
    {
      "@type": "Question",
      "name": "Does CFO Bridge provide cross-border financial strategy across India, the UAE, and the broader MENA region?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. CFO Bridge operates across India, the UAE, and the broader MENA region, making us uniquely positioned to support businesses with cross-border financial strategy. Whether you are expanding from India into the UAE, setting up a holding structure across GCC markets, or managing inter-company transactions, our team has the regulatory and strategic expertise to guide you."
      }
    }
  ]
};